import * as types from "../../../constants";

const initialState = {
  loading: false,
  reportList: [],
  reportFilterList: [],
  filterEnabled: false,
  reportListFilter: {
    duplicate: 0,
    anomaly: 0,
    all: 1,
  },
  reportDetails: {},
  sort: { order: "desc", orderBy: "reportId" },
};

export default function reducer(state = initialState, action) {
  let filteredReportList = [];

  switch (action.type) {
    case types.REPORT_SORT:
      return {
        ...state,
        sort: { order: action.payload.order, orderBy: action.payload.orderBy },
      };
    case types.REPORT_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.REPORT_LOADING_DISABLE:
      return {
        ...state,
        loading: false,
      };
    case types.RETRIEVE_REPORT_LIST:
      return {
        ...state,
        reportListAll: [...action.payload],
        reportList: [...action.payload],
        loading: false,
      };

    case types.RETRIEVE_REPORT_LIST_FILTER:
      let duplicatesList = [];
      let anomaliesList = [];

      if (action.payload.duplicate) {
        duplicatesList = state.reportList.filter(
          (report) => report.duplicateTest === 1 || report.duplicateTest === 2
        );
      }

      if (action.payload.anomaly) {
        anomaliesList = state.reportList.filter((report) =>
          report.anomalies.includes(1)
        );
      }

      if (action.payload.all) {
        return {
          ...state,
          reportFilterList: [],
          filterEnabled: false,
          reportListFilter: action.payload,
        };
      }

      const filteredTestList = duplicatesList.concat(anomaliesList);
      const uniqueList = Array.from(new Set(filteredTestList));

      return {
        ...state,
        reportFilterList: uniqueList,
        filterEnabled: true,
        reportListFilter: action.payload,
      };

    case types.RETRIEVE_REPORT_DETAIL:
      return {
        ...state,
        reportDetails: action.payload,
        loading: false,
      };
    case types.DELETE_REPORT:
      filteredReportList = state.reportList.filter(
        (report) => report.reportId !== action.payload
      );

      return {
        ...state,
        reportList: [...filteredReportList],
        loading: false,
      };
    case types.RESET_REPORTS:
      return {
        ...state,
        reportDetails: {},
        reportList: [],
      };
    default:
      return state;
  }
}
